'use client';

import { Input } from '@holistic/components';
import { ShieldCheck } from '@holistic/components/icons';

type SerialNumberFieldProps = {
  value: string;
  onChange: (v: string) => void;
  error: string | null;
  onPickFromWarranties: (() => void) | null;
};

const SerialNumberField = ({
  value,
  onChange,
  error,
  onPickFromWarranties,
}: SerialNumberFieldProps) => (
  <div className="flex flex-col gap-2">
    <div className="flex items-baseline justify-between gap-4">
      <label className="text-sm font-medium text-gray-700">
        Cihaz seri numarası <span className="text-gray-400">(opsiyonel)</span>
      </label>
      {onPickFromWarranties && (
        <button
          type="button"
          onClick={onPickFromWarranties}
          className="text-primary flex shrink-0 cursor-pointer items-center gap-1 text-xs font-medium hover:underline"
        >
          <ShieldCheck className="size-3.5" />
          Garantilerimden seç
        </button>
      )}
    </div>

    <Input
      value={value}
      onChange={(e) => onChange(e.target.value.toUpperCase())}
      placeholder="Örn: ABC-12345"
      className="font-mono uppercase"
      error={error ?? undefined}
    />

    {!error && (
      <p className="text-xs leading-relaxed text-gray-400">
        Genelde kutu üzerinde veya Ayarlar → Hakkında bölümündedir.
        Bilmiyorsanız boş bırakın, atölyemiz kaydeder.
      </p>
    )}
  </div>
);

export default SerialNumberField;
